import { __rest } from 'tslib';
import React from 'react';
import { useColor } from '../../theme/Theme.js';
import { Icon } from '../Icon.js';

const DoneCircle = React.forwardRef((_a, ref) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const _color = useColor(color);
    return (React.createElement(Icon, Object.assign({ "data-testid": 'tend-ui-done-circle-icon' }, props, { ref: ref, color: _color }),
        React.createElement("svg", { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'currentColor', xmlns: 'http://www.w3.org/2000/svg' },
            React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM16.6839 10.7295C17.0869 10.3518 17.1073 9.71897 16.7295 9.31606C16.3518 8.91315 15.719 8.89274 15.3161 9.27047L10.6667 13.6293L8.68394 11.7705C8.28103 11.3927 7.6482 11.4131 7.27047 11.8161C6.89274 12.219 6.91315 12.8518 7.31606 13.2295L9.98273 15.7295C10.3674 16.0902 10.966 16.0902 11.3506 15.7295L16.6839 10.7295Z', fill: 'currentColor' }))));
});
DoneCircle.displayName = 'DoneCircle';

export { DoneCircle };
//# sourceMappingURL=DoneCircle.js.map
